var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "date-picker" },
    [
      _c("span", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isClearVisible,
            expression: "isClearVisible"
          }
        ],
        staticClass: "fa fa-times",
        on: { click: _vm.clear }
      }),
      _vm._v(" "),
      _c("date-picker", {
        ref: "datePicker",
        attrs: {
          name: _vm.name,
          value: _vm.date,
          "input-class": "form-control",
          config: _vm.config,
          disabled: _vm.disabled,
          placeholder: _vm.placeholder
        },
        on: { input: _vm.onInput }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46bb2877", { render: render, staticRenderFns: staticRenderFns })
  }
}